import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { saveAs } from 'file-saver';
import { ClientService } from 'src/app/services/client.service';
import { ContextService } from 'src/app/services/context.service';
import { StripeService } from 'src/app/services/stripe.service';

@Component({
	selector: 'app-welcome-purchase-quotes',
	templateUrl: './purchase-quotes.component.html',
	styleUrls: ['./purchase-quotes.component.css']
})
export class WelcomePurchaseQuotesComponent implements OnInit {
	loadingCancelQuoteId;
	loadingDownloadQuoteId;
	loadingAcceptQuoteId;

	constructor(
		private clientService: ClientService,
		public contextService: ContextService,
		private stripeService: StripeService,
		private router: Router
	) { }

	ngOnInit() { }

	/** BUTTON ACTIONS */

	selectAcceptQuote(quoteId) {
		this.loadingAcceptQuoteId = quoteId;
		this.stripeService.acceptStripeQuote(this.contextService.stripeCustomerId, quoteId)
			.subscribe((response) => {
				this.retrieveQuotes();
			});
	}

	selectDownloadQuote(quoteId) {
		this.loadingDownloadQuoteId = quoteId;
		this.stripeService.getStripeQuoteDownloadStream(this.contextService.stripeCustomerId, quoteId)
			.subscribe((result) => {
				saveAs(result, "quote.pdf");
				this.loadingDownloadQuoteId = null;
			});
	}

	selectDeleteQuote(quoteId) {
		this.loadingCancelQuoteId = quoteId;
		this.stripeService.cancelStripeQuote(this.contextService.stripeCustomerId, quoteId)
			.subscribe((response) => {
				if (response) {
					// Remove the quote from the array 
					let item = this.contextService.quotes.find(d => d.id === quoteId);
					if (item) {
						this.contextService.quotes.splice(this.contextService.quotes.indexOf(item), 1);

						if (this.contextService.quotes.length == 0) {
							this.router.navigate(['/welcome/purchase']);
						}
					}
				}
				this.loadingCancelQuoteId = null;
			});
	}

	selectGenerateAnotherQuote() {
		this.router.navigate(['/welcome/purchase']);
	}

	// Retrieve the quotes and navigate to the purchase configure page
	retrieveQuotes() {
		this.stripeService.getStripeQuotes(this.contextService.stripeCustomerId)
			.subscribe((quotes) => {
				this.formatQuoteDates(quotes);
			});
	}

	formatQuoteDates(quotes) {
		for (let quote of quotes) {
			let d = new Date(0);
			let utc = quote.expiresAt;
			d.setUTCSeconds(utc);

			quote.expiresAt = d;
		}

		this.contextService.quotes = quotes;
		this.contextService.clientDetailProcore.isTrial = false;

		this.router.navigate(['/welcome/purchase/configure']);
	}
}